export default {
  test: 'test',
  hello: 'salut',
}
